













































































import { Component, Prop, Vue } from 'vue-property-decorator';

import {
  SurveyProperty,
  SurveySite,
  FaunaSurvey,
  FaunaMedia,
  DetectionBbox,
  FaunaSurveyStatus,
} from '@/api';

import UserAvatar from '@/components/common/UserAvatar.vue';

@Component({
  components: {
    UserAvatar,
  },
})
export default class ItemBreadcrumb extends Vue {
  @Prop({ default: null }) readonly property: SurveyProperty | null;

  @Prop({ default: null }) readonly site: SurveySite | null;

  @Prop({ default: null }) readonly survey: FaunaSurvey | null;

  @Prop({ default: null }) readonly faunaMedia: FaunaMedia | null;

  @Prop({ default: null }) readonly bbox: DetectionBbox | null;

  @Prop({ default: false }) readonly showUser: boolean;

  get editSurveyLink() {
    if (!this.survey) {
      return null;
    }

    const isDraft = this.survey.status === FaunaSurveyStatus.draft;
    const isProcessing =
      this.survey.status === FaunaSurveyStatus.published &&
      this.survey.snsStatusPredicted < this.survey.totalCount;

    if (isDraft || isProcessing) {
      return {
        name: 'property-surveys-edit',
        params: {
          propertyId: this.property ? this.property.id : undefined,
          surveyId: this.survey.id,
        },
      };
    }
    return {
      name: 'classifier',
      params: {
        propertyId: this.property ? this.property.id : undefined,
        faunaSurveyId: this.survey.id,
      },
    };
  }
}
